//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment'
import axios from 'axios'
import _ from 'lodash'

export default {
    layout: 'withHeader',
    // middleware: 'guest',

    data(){ return {
        debounceTime: 100,
        video: '',
        source: 'https://img.youtube.com/vi/%ID/maxresdefault.jpg',
        full_image_url: '',
        defaultBackgroundImage: require('~/../images/bg/black_polygon_.jpg'),
        found: false,
        data: null,
        message: { text: 'Waiting for your Video ID .... ', type: 'info' },

        showStoragePath: false,

        YouTubeImageClass: {
            shadow: true,
            border: false,
        },

        settings: {

        }
    }},

    metaInfo(){ return {
        title: 'Search your favorite Thumbnail',
        link: [
            { rel: 'canonical', href: window.location.href }
        ],
        meta: this.$rm.getMeta(this), //this.$route.meta
    }},

    mounted(){
        if(this.$route.query.v && this.$route.params.video){
            this.video = this.get_video_id_of_full_url(this.$route.fullPath)
        }
        else if(this.$route.params.video)
        this.video = this.$route.params.video
    },

    computed: {
        bgImage(){
            if(this.video && this.video.length < 4) return;
            if(this.found) return this.full_image_url
            return;
        },

        currentTime(){ return moment().format('H:m @ DD.MM.Y') },

        getUserName(){
            let user = this.data.user
            if(!user) return "Guest"
            if(user) return user.name
        }
    },

    watch: {
        video(val){
            if(!val || val.length == 0){
                this.set_message("Waiting for your Video ID ... ", 'info')
                this.found = false
                return false
            }

            if(val.length > 0 && val.length < 9){
                this.set_message("Type more... Video ID's are longer then " + val.length + " Characters... ", 'info')
                return false
            }

            if(val.length > 11 && val.includes('youtu')){
                this.set_message("Okey, looks like you add a full path, we gonna crop it.. ")
                let id = this.get_video_id_of_full_url(val)

                if(id)
                setTimeout( () => this.video = id, 300)

                return false
            }

            if(val.length > 10){
                this.set_message("Okay, checking your current input now " + this.video, 'info')
            }

            this.check_image()
        }
    },

    filters: {
        getDate(val){
            return moment(val).format('DD.MM.YYYY')
        },

        getTime(val){
            return moment(val).format('H:mm @ DD.MM.Y')
        },
    },

    methods: {
        get_video_id_of_full_url(val){
            var id = val.match("v=([a-zA-Z0-9\_\-]+)&?")
                id = id ? id[1] : null
            // var list = val.match("list=([a-zA-Z0-9\-\_]+)&?");

            if(!id){
                if(this.$route.query.v && this.$route.params.video){
                    id = this.$route.query.v
                }
            }

            return id
        },

        set_full_image_url(){
            return "https://img.youtube.com/vi/" + this.video + "/maxresdefault.jpg"
        },

        get_full_image_string(data){
            if(!data.video) return ''

            let video = data.video
            let url  = video.url
            let path = video.path

            if(this.showStoragePath)
            return path ? '/storage' + path  : url

            return url
        },

        check_image: _.debounce(function(){ this.search_image_request() }, 100),

        search_image_request(){
          console.log('search request on route ', this.$route.name)

          if(!this.$route.name.includes('search')){
              console.log('YTM::Search | Stopping re-debounce')
              return
          }

          axios.get('/api/ytm/v1/check-image/' + this.video)
                .then((r) => {
                    var data = r.data
                    this.data = data
                    this.found = data.found
                    this.full_image_url = this.get_full_image_string(r.data)

                    return data;
                })
                .then((r) => {
                    if(r.found){
                      this.message.text = "Video Thumbnail found"
                      this.message.type = 'success'

                      if(this.$route.params.video != this.video){
                          this.$router.replace({ name: 'search.video', params:{ video: this.video } })
                      }

                    } else {
                      this.message.text = "Video Thumbnail for " + this.video + " couldn't been found"
                      this.message.type = 'info'
                    }
                })
                .catch( (error) => this.notfound(error) )
        },

        _found(){
            this.set_message('Found Video', true)
            router.push({ name: 'ytc.video.id', params:{ video: this.video } })
            console.log(this.video + ' has been found ... router update?')
        },

        notfound(r){
            this.set_message('Video Thumbnail for ID ' + this.video + ' couldnt been found', false)
            console.log(r)
        },

        set_message(message, type){
            this.message.text = message
            this.message.type = 'alert-' + type
        }
    }
}
